import React from 'react';

import { StatsSection, StatsRow, StatBox, StatNumber, StatLabel } from '../styles';

const STATS = [
  { number: '15,254', label: 'Libros' },
  { number: '1,287', label: 'Vendedores' },
  { number: '7,589', label: 'Ventas' },
  { number: '97%', label: 'Satisfacción' },
];

export default function StatsCounter() {
  return (
    <StatsSection>
      <StatsRow>
        {STATS.map((stat) => (
          <StatBox key={stat.label}>
            <StatNumber>{stat.number}</StatNumber>
            <StatLabel>{stat.label}</StatLabel>
          </StatBox>
        ))}
      </StatsRow>
    </StatsSection>
  );
}
